import { StandardColorSwatchButtonSkin, WideColorSwatchButtonSkin } from './color-swatch-button-skin.mjs';

function getColorSwatchComponentBySkin(skin) {
    switch (skin) {
        case "standard":
        case "minimal":
        case "tight":
            return StandardColorSwatchButtonSkin;
        case "wide":
            return WideColorSwatchButtonSkin;
        default:
            return StandardColorSwatchButtonSkin;
    }
}

export { getColorSwatchComponentBySkin as default };
//# sourceMappingURL=index.mjs.map
